// Utility functions for the application

export const formatCurrency = (amount) => {
  return `${amount.toFixed(2)} د.ج`;
};

export const formatDate = (date) => {
  if (!date) return '';
  
  const options = { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  };
  
  return new Date(date).toLocaleDateString('ar-DZ', options);
};

export const formatTime = (date) => {
  if (!date) return '';
  
  const options = { 
    hour: '2-digit', 
    minute: '2-digit' 
  };
  
  return new Date(date).toLocaleTimeString('ar-DZ', options);
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'pending':
      return '#FF9800'; // Orange
    case 'accepted':
      return '#2196F3'; // Blue
    case 'rejected':
      return '#F44336'; // Red
    case 'completed':
      return '#4CAF50'; // Green
    default:
      return '#9E9E9E'; // Grey
  }
};

export const getStatusText = (status) => {
  switch (status) {
    case 'pending':
      return 'معلق';
    case 'accepted':
      return 'مقبول';
    case 'rejected':
      return 'مرفوض';
    case 'completed':
      return 'مكتمل';
    default:
      return status;
  }
};

export const getMonthName = (month) => {
  const months = [
    'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
    'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
  ];
  return months[month - 1];
};

export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

export const validatePhone = (phone) => {
  // Simple validation for Algerian phone numbers
  const re = /^(0|00213)?[5-7][0-9]{8}$/;
  return re.test(phone);
};

export const truncateText = (text, maxLength) => {
  if (!text) return '';
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};